import { FC, Fragment } from 'react';

interface Props {
  amountOfMessages: string;
}

const InfoButtonContent: FC<Props> = ({ amountOfMessages }) => {
  // This regex split the amountOfMessages by every break line (\n)
  const messages = amountOfMessages.split(/(\r\n|\r|\n)/);

  return (
    <>
      {messages.map((message, index) => (
        <Fragment key={index + ' - ' + message}>{message === '\n' ? <br /> : <p>{message}</p>}</Fragment>
      ))}
    </>
  );
};

export default InfoButtonContent;
